<template>
  <div class="ce-wrapper">
    <div v-if="editMode" :class="'ce ce-' + content.type + ' ce-edit-mode'">
      <div class="edit-header d-flex align-items-center">
        <h5 class="mb-0">
          <span class="text-success"><i class="fas fa-file-alt"></i></span>
          Lista med filer
        </h5>
        <CeButtonGroup
          v-on:on-remove-click="onRemoveClick"
          v-on:on-arrow-up-click="onArrowUp"
          v-on:on-arrow-down-click="onArrowDown"
        />
      </div>
      <b-form-group>
        <b-form-input
          @change="updateHeadline"
          :value="content.headline"
          :id="'ceListFilesHeadline' + content.id"
          placeholder="Rubrik för listan... (valfritt)"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Ladda upp filer">
        <b-form-file
          :ref="'file-input-' + content.id"
          @change="uploadFiles"
          :id="'ceListFilesItems' + content.id"
          multiple
          browse-text="Välj filer"
          placeholder="Välj filer eller dra &amp; släpp här..."
        >
        </b-form-file>
      </b-form-group>
      <b-form-group>
        <div class="ce-list">
          <!-- <label>Uppladdade filer</label> -->
          <div
            v-for="file in content.files"
            :key="file.id"
            class="ce-list-item"
          >
            <div class="ce-list-item-prefix align-items-start">
              <span style="font-size: 2.25rem;" class="text-primary"
                ><i :class="'fas fa-file' + file.type"></i
              ></span>
            </div>
            <div class="ce-list-item-desc">
              <h6 class="mb-0">{{ file.name }}</h6>
            </div>
            <div class="ce-list-item-action">
              <b-button
                @click="deleteFile(file)"
                variant="flat-primary"
                size="sm"
                ><i class="fas fa-trash"></i
              ></b-button>
            </div>
          </div>
        </div>
      </b-form-group>
    </div>
    <div v-else :class="'ce ce-' + content.type">
      <h3 v-if="content.headline" class="ce-headline mb-1">
        {{ content.headline }}
      </h3>
      <div class="ce-list">
        <div v-for="file in content.files" :key="file.id" class="ce-list-item">
          <div class="ce-list-item-prefix align-items-start">
            <span style="font-size: 4rem;" class="text-primary"
              ><i :class="'fas fa-file' + file.type"></i
            ></span>
          </div>
          <div class="ce-list-item-desc">
            <h6 class="mb-0">{{ file.name }}</h6>
            <p>
              <small>{{ file.type }}</small>
            </p>
          </div>
          <div class="ce-list-item-action">
            <b-button @click="downloadFile(file)" variant="primary" size="sm"
              >Hämta <i class="fas fa-download"></i
            ></b-button>
            <!-- <a :href="file.url" class="btn btn-primary btn-sm">Visa</a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton, BFormGroup, BFormInput, BFormFile } from "bootstrap-vue";
import CeButtonGroup from "@/components/Article/ContentElements/CeButtonGroup";
import ContentElementButtonGroupMixin from "@/models/mixins/ContentElementButtonGroupMixin";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("editArticle");

export default {
  name: "CeListFiles",
  props: {
    content: {},
    editMode: Boolean,
  },
  methods: {
    ...mapActions(["updateContent", "uploadContentFiles", "removeContentFile"]),
    updateHeadline(headline) {
      let content = this.content;
      content.headline = headline;
      this.updateContent(content);
    },
    uploadFiles(event) {
      const files = event.target.files;
      let payload = { content: this.content, files: files };
      this.uploadContentFiles(payload);

      this.$refs["file-input-" + this.content.id].reset();
    },
    deleteFile(file) {
      let payload = { content: this.content, file: file };
      this.removeContentFile(payload);
    },
    downloadFile(file) {
      this.$store.dispatch("downloadFile", file);
    },
  },
  components: {
    BButton,
    CeButtonGroup,
    BFormGroup,
    BFormInput,
    BFormFile,
  },
  mixins: [ContentElementButtonGroupMixin],
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/variables/_variables.scss";
.ce-list-item {
  display: flex;
  align-items: center;
  padding: 0.25rem;
  border-bottom: 1px solid #ebe9f1;
}
.ce-list-item:last-child {
  border-bottom: none;
}
.ce-list-item-prefix {
  padding: 0.75rem 0;
}
.ce-list-item-desc {
  padding: 0.75rem 0 0.75rem 0.75rem;
}
.ce-list-item-action {
  padding: 0.75rem 0;
}
.ce-list-item-desc {
  margin-right: auto;
}
</style>
